import React from "react";
import Frame from "../chrome/Frame";
import Seo from "../chrome/Seo";
import CapGrid from "../sections/CapGrid";
import Invite from "../sections/Invite";

const Services = () => (
  <Frame>
    <Seo title="Services" description="Eleven capabilities for international brands entering Türkiye — market entry strategy, localisation, performance, SEO, social, PR, retail, e-commerce, customer care and analytics." />

    <section className="svc-hero">
      <div className="shell">
        <div className="crumb">
          <a href="/">Home</a><span className="sep">/</span> Services
        </div>
        <span className="eyebrow">What we do</span>
        <h1>Eleven capabilities to launch and scale a brand in Türkiye.</h1>
        <p className="lede">
          Every capability can be engaged on its own. Most international brands work with us across four or more in
          parallel, sequenced to match where the launch actually is — first listing, first season, or year-two scale.
        </p>
      </div>
    </section>

    <section className="band">
      <div className="shell">
        <CapGrid />
      </div>
    </section>

    <Invite />
  </Frame>
);

export default Services;
